import PropTypes from "prop-types"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Card, Row, CardBody, Col, Table, CardImg, Badge } from "reactstrap"
import ReactCardFlip from "react-card-flip"
import { formatNumber } from "../../util/common"
import CopyToClipboard from "react-copy-to-clipboard"
import { Tooltip } from "antd"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import toastr from "toastr"
import ReactTimeAgo from "react-time-ago"
import SimpleBar from "simplebar-react"
import { NO_PERMISSION_MESSAGE } from "constants/uiConstants"

const ChallengeCard = props => {
  const [isFlipped, setIsFlipped] = useState(false)
  const [challenge, setchallenge] = useState(props.challenge)
  const dispatch = useDispatch()
  const customClassname = props.customClassname || ""
  const enableEdit = props.enableEdit === false ? false : true
  const realStatPermissionchallenge =
    // props.currentUser.jotUserType < 3 ||
    props.currentUser.permissions &&
    props.currentUser.permissions.includes("VIEW_REAL_STATS")

  const _onEdit = () => {
    props.history.push(
      `/challenge/manage?challengeUuid=${challenge.challenge_id}`
    )
  }

  const _getRealStats = () => {
    return (
      <>
        <tr className="text-start">
          <th scope="row">Real Views:</th>
          <td>{formatNumber(challenge.view_count) || 0}</td>
        </tr>
        <tr className="text-start">
          <th scope="row">Real Likes:</th>
          <td>{formatNumber(challenge.like_count) || 0}</td>
        </tr>
        <tr className="text-start">
          <th scope="row">Real Shares:</th>
          <td>{formatNumber(challenge.share_count) || 0}</td>
        </tr>
        <tr className="text-start">
          <th scope="row">Real Downloads:</th>
          <td>{formatNumber(challenge.download_count) || 0}</td>
        </tr>
      </>
    )
  }
  return (
    <ReactCardFlip isFlipped={isFlipped} flipDirection={"horizontal"}>
      <Card
        className={`${customClassname} text-center shadow-lg`}
        style={{ height: "510px" }}
      >
        <CardBody className="px-0 py-0">
          <div
            role="button"
            onClick={() =>
              props.pageSource && props.pageSource === "manageCollection"
                ? props.onEditClick(challenge)
                : props.pageSource && props.pageSource === "searchAndSelect"
                ? () => {}
                : _onEdit()
            }
          >
            <CardImg
              top
              src={
                challenge.banner_url
                  ? // && !challenge.bannerUrl.includes("undefined")
                    challenge.banner_url
                  : "data:image/png;base64,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"
              }
              width="100%"
              height="200px"
            />

            <h5 className="font-size-20 my-3 text-truncate text-dark">
              {challenge.hashtag}
            </h5>
            <SimpleBar style={{ height: "80px" }}>
              <div>
                <h6>{challenge.description}</h6>
              </div>
            </SimpleBar>
          </div>

          <div className="my-3 mb-1">
            <Badge pill className="badge-soft-warning m-1">
              <div className="p-1 font-size-13"> {challenge.status}</div>
            </Badge>

            <Badge pill className="badge-soft-info m-1">
              <div className="p-1 font-size-13">{challenge.type}</div>
            </Badge>
            {challenge.created_date && (
              <Tooltip title="Created">
                <Badge pill className="badge-soft-success m-1">
                  <div className="p-1 font-size-13">
                    <ReactTimeAgo
                      date={
                        Number.isNaN(challenge.created_date)
                          ? Date.parse(challenge.created_date)
                          : challenge.created_date
                      }
                      locale="en-US"
                    />
                  </div>
                </Badge>
              </Tooltip>
            )}
          </div>

          <div className="d-flex justify-content-around align-items-center border-top py-3">
            <div className="d-flex flex-column">
              <i
                className="bx bx-show"
                style={{ padding: "2px", fontSize: "16px" }}
              />
              <span>
                {formatNumber(challenge.view_count + challenge.fk_views) || 0}
              </span>
            </div>
            <div className="d-flex flex-column">
              <i
                className="bx bx-like"
                style={{ padding: "2px", fontSize: "16px" }}
              />
              <span>
                {formatNumber(challenge.like_count + challenge.fk_likes) || 0}
              </span>
            </div>
            <div className="d-flex flex-column">
              <i
                className="bx bx-share-alt"
                style={{ padding: "2px", fontSize: "16px" }}
              />
              <span>
                {formatNumber(challenge.share_count + challenge.fk_shares) || 0}
              </span>
            </div>
            <div>
              <Tooltip title="View More">
                <i
                  className="bx bx-play"
                  role="button"
                  style={{ fontSize: "20px" }}
                  onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    setIsFlipped(true)
                  }}
                />
              </Tooltip>
            </div>
          </div>

          <Row>
            <Col lg={1} xl={2} md={1} sm={3}></Col>
          </Row>
        </CardBody>
        <div className="contact-links d-flex font-size-20 p-2 bg-light border-top">
          <div className="flex-fill">
            <CopyToClipboard
              text={
                props.pageSource && props.pageSource === "manageCollection"
                  ? challenge.collectionId
                  : challenge.challenge_id
              }
              onCopy={e => {
                toastr.success("Copied sucessfully!")
              }}
            >
              <Tooltip
                title={
                  props.pageSource && props.pageSource === "manageCollection"
                    ? "Copy Collection Id"
                    : "Copy Challenge ID"
                }
              >
                <i role="button" className="bx bx-copy" />
              </Tooltip>
            </CopyToClipboard>
          </div>
          <div className="flex-fill">
            <Tooltip title="Edit">
              <i
                role="button"
                className="bx bx-edit-alt"
                onClick={() => {
                  if (
                    !props.currentUser?.permissions?.includes(
                      "VIEW_MANAGE_CHALLENGE"
                    )
                  ) {
                    toastr.error(NO_PERMISSION_MESSAGE)
                    return
                  }
                  props.pageSource && props.pageSource === "manageCollection"
                    ? props.onEditClick(challenge)
                    : _onEdit()
                }}
              />
            </Tooltip>
          </div>
          <div className="flex-fill">
            <Tooltip title="Edit In New Window">
              <Link
                to={`/challenge/manage?challengeUuid=${challenge.challenge_id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bx-link-external"></i>
              </Link>
            </Tooltip>
          </div>
        </div>
      </Card>
      <Card className="text-center shadow-lg" style={{ height: "510px" }}>
        <CardBody className="px-0 py-0">
          <Row className="my-sm-2">
            <Col>
              <div className="avatar-xs">
                <div className="avatar-title rounded-circle bg-light">
                  <span
                    title={
                      challenge.display_persona || "display persona not known"
                    }
                    className={
                      "avatar-title rounded-circle bg-light bg-" +
                      "secondary" +
                      " text-warning" +
                      " font-size-16" +
                      " font-weight-semibold"
                    }
                  >
                    <i className="bx bx-bar-chart" />
                  </span>
                </div>
              </div>
            </Col>
            <Col className="d-flex justify-content-end me-1">
              <div
                className="avatar-xs"
                role="button"
                onClick={() => setIsFlipped(false)}
              >
                <div className="avatar-title rounded-circle bg-light">
                  <span
                    className={
                      "avatar-title rounded-circle bg-light bg-" +
                      "secondary" +
                      " text-dark" +
                      " font-size-16" +
                      " font-weight-semibold"
                    }
                  >
                    <i className="fas fa-times-circle" />
                  </span>
                </div>
              </div>
              <div></div>
            </Col>
          </Row>
          <Row>
            <div
              className="table-responsive"
              role="button"
              onClick={() =>
                props.pageSource && props.pageSource === "manageCollection"
                  ? props.onEditClick(challenge)
                  : props.pageSource && props.pageSource === "searchAndSelect"
                  ? () => {}
                  : _onEdit()
              }
            >
              <Table className=" mb-0 table-striped">
                <tbody>
                  <tr className="text-start">
                    <th scope="row">Views:</th>
                    <td>
                      {formatNumber(
                        challenge.fk_views + challenge.view_count
                      ) || 0}
                    </td>
                  </tr>
                  <tr className="text-start">
                    <th scope="row">Likes:</th>
                    <td>
                      {formatNumber(
                        challenge.fk_likes + challenge.like_count
                      ) || 0}
                    </td>
                  </tr>
                  <tr className="text-start">
                    <th scope="row">Shares:</th>
                    <td>
                      {formatNumber(
                        challenge.fk_shares + challenge.share_count
                      ) || 0}
                    </td>
                  </tr>
                  <tr className="text-start">
                    <th scope="row">Downloads:</th>
                    <td>
                      {formatNumber(
                        challenge.fk_downloads + challenge.download_count
                      ) || 0}
                    </td>
                  </tr>
                  {realStatPermissionchallenge && _getRealStats()}
                </tbody>
              </Table>
            </div>
          </Row>
        </CardBody>
      </Card>
    </ReactCardFlip>
  )
}

ChallengeCard.propTypes = {
  challenge: PropTypes.object,
}

export default withRouter(ChallengeCard)
